import { Injectable } from '@angular/core';

import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({ providedIn: 'root' })
export class TailorAccessService {
    constructor(private dataTask: DataTaskService) {}

    /**
     * @datatask 2094
     * @datataskName sp_ws_p2_w_tailoraccesses_list
     * @param params Tailor access list parameters.
     * @returns Promise containing the available tailor accesses.
     */
    public getTailorAccessesList(params: TailorAccessListParams): Promise<TailorAccessListItem[]> {
        return this.dataTask.Post(2094, params);
    }
}

export interface TailorAccessListParams {}

export interface TailorAccessListItem {
    item_id: string | number;
    item_name: string;
}
